import image2 from '../../assets/programs/future_changemakers/image2.webp'
import image3 from '../../assets/programs/future_changemakers/image3.webp'
import image4 from '../../assets/programs/future_changemakers/image4.webp'
import image5 from '../../assets/programs/future_changemakers/image5.webp'
import image6 from '../../assets/programs/future_changemakers/image6.webp'

const grip_data = {
    "title": "Changemakers",
    "description": "Change Makers Summer Bootcamp is a transformative initiative by the Office of Academic Outreach and Makerspace at IIT Delhi. The program is about learning by doing, where we host passionate makers to use their interests and skills to bring about a positive change in society. This is an experiment to connect bright high schoolers and first-year undergraduates with the brains and the brawn that are the R&D facilities of the premier institutions of the country. It is a wonderful opportunity to work with like-minded students from different parts of the country.  For more details: https://www.youtube.com/watch?v=jP1wMhxv5bk",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        {
                            "src": image2,
                            "desc": ""
                        },
                        {
                            "src": image3,
                            "desc": ""
                        },
                        {
                            "src": image4,
                            "desc": ""
                        },
                        {
                            "src": image5,
                            "desc": ""
                        },
                        {
                            "src": image6,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default grip_data;